// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-small-button-864e5244","buttonLoading":"skins-small-buttonLoading-e9335b83"};